import { render, staticRenderFns } from "./error-circle.vue?vue&type=template&id=29c0dfe5&"
import script from "./error-circle.vue?vue&type=script&lang=js&"
export * from "./error-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c0dfe5')) {
      api.createRecord('29c0dfe5', component.options)
    } else {
      api.reload('29c0dfe5', component.options)
    }
    module.hot.accept("./error-circle.vue?vue&type=template&id=29c0dfe5&", function () {
      api.rerender('29c0dfe5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/error-circle.vue"
export default component.exports